import { ReturnRequestLogDto } from "@babackapp/private-api-client/types";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@babackapp/ui/components/accordion";
import ActivityWrapper from "./activity-wrapper";
import ActivityIconWrapper from "./activity-icon-wrapper";
import ActivityContentWrapper from "./activity-content-wrapper";
import { ActivityItemHeader } from "./activity-item-header";
import klaviyoLogo from "@/assets/integrations/klaviyo-logo.png";

// On ne traduit pas les eventName, ils sont déjà explicites

type KlaviyoActivityProps = {
  activity: ReturnRequestLogDto;
};

export default function KlaviyoActivity({ activity }: KlaviyoActivityProps) {
  const params = activity.params as {
    eventName: string;
    eventProperties: string;
  };
  let formattedEventProperties: string;
  try {
    formattedEventProperties = JSON.stringify(
      JSON.parse(params.eventProperties),
      null,
      2,
    );
  } catch {
    formattedEventProperties = params.eventProperties;
  }
  return (
    <ActivityWrapper>
      <ActivityIconWrapper>
        <img src={klaviyoLogo} className="size-4" />
      </ActivityIconWrapper>
      <ActivityContentWrapper>
        <div className="flex items-center gap-2 flex-1 justify-between w-full">
          <Accordion type="single" collapsible className="flex-1">
            <AccordionItem value="item-1" className="border-0">
              <AccordionTrigger className="p-0 w-full">
                <ActivityItemHeader
                  title=""
                  timestamp={activity.date}
                  description={null}
                >
                  <div className="flex flex-col gap-0">
                    <div className="flex items-center gap-2">
                      <span>Klaviyo</span>
                      <span className="font-normal text-xs underline">
                        {params.eventName}
                      </span>
                    </div>
                  </div>
                </ActivityItemHeader>
              </AccordionTrigger>
              <AccordionContent>
                <pre className="mt-2 rounded-md bg-muted p-4 text-xs overflow-x-auto whitespace-pre-wrap">
                  {formattedEventProperties}
                </pre>
              </AccordionContent>
            </AccordionItem>
          </Accordion>
        </div>
      </ActivityContentWrapper>
    </ActivityWrapper>
  );
}
